/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FcResponsiveAgDropDownListModule} from '../fc-ag-drop-down-list/fc-ag-drop-down-list.module';
import {FcAgDatePickerComponent} from './fc-ag-date-picker.component';
import {FcAgCalendarComponent} from './component/fc-ag-calendar/fc-ag-calendar.component';


/**
 * Date picker module with Angular.
 */
@NgModule({
    declarations: [
        FcAgDatePickerComponent,
        FcAgCalendarComponent
    ],
    imports: [CommonModule, BrowserModule, ReactiveFormsModule, FormsModule, FcResponsiveAgDropDownListModule],
    exports: [
        FcAgDatePickerComponent,
        FcAgCalendarComponent
    ]
})
export class FcAgDatePickerModule {
}
